import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface Language {
  id: string;
  code: string;
  name: string;
  native_name: string;
  is_active: boolean;
  is_default: boolean;
  flag_emoji: string | null;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export const useLanguages = () => {
  const [languages, setLanguages] = useState<Language[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    try {
      const { data, error } = await supabase
        .from('languages')
        .select('*')
        .eq('is_active', true)
        .order('sort_order');

      if (error) {
        console.error('Error fetching languages:', error);
        return;
      }

      setLanguages(data || []);
    } catch (error) {
      console.error('Error fetching languages:', error);
    } finally {
      setLoading(false);
    }
  };

  const getDefaultLanguage = () => {
    return languages.find(lang => lang.is_default) || languages[0];
  };

  const getLanguageByCode = (code: string) => {
    return languages.find(lang => lang.code === code);
  };

  return { 
    languages, 
    loading, 
    refetch: fetchLanguages, 
    getDefaultLanguage,
    getLanguageByCode
  };
};